// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6tSJS","logoContainer":"Logo_logoContainer__0LyIw"};